// extracted by mini-css-extract-plugin
export default {"main":"main_main__ivpKR","row":"main_row__lcepj","dashboard":"main_dashboard__XpYxB","footerNote":"main_footerNote__U+NQu"};